import React from 'react';
import { Drawer, List, ListItem, ListItemText, Toolbar, Divider, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const drawerWidth = 240;

const AdminSidebar = () => {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: '#f5f5f5'
        }
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: 'auto' }}>
        <List>
          <ListItem button component={Link} to="/admin/dashboard">
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem button component={Link} to="/admin/players">
            <ListItemText primary="Players" />
          </ListItem>
          <ListItem button component={Link} to="/admin/build-workout">
            <ListItemText primary="Build Workout" />
          </ListItem>
        </List>
        <Divider />
      </Box>
    </Drawer>
  );
};

export default AdminSidebar;
